<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="order" formName="order" title="订单支出" />
      <BaseForm ref="driver" formName="driver" title="司机工资" />
      <BaseForm ref="member" formName="member" title="会员消费" />
      <Account ref="account" />
    </qx-card>
    <SubBtnBox @sub="sub"/>
  </div>
</template>

<script>
import BaseForm from './base';
import Account from './account';
import SubBtnBox from 'components/subBtnBox';
import {
  riskCapital,
  riskCapitalEdit,
} from 'api/system';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Account,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/system/risk/money/edit',
      formComponents: ['order', 'driver', 'member', 'account'],
      editParams: {
        nums: 4,
      },
    };
  },
  methods: {
    editApi: riskCapitalEdit,
    async detailApi () {
      // 订单支出
      const orderRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 1,
        state: 1,
      });
      // 司机工资
      const driverRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 2,
        state: 1,
      });
      // 会员消费
      const memberRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 3,
        state: 1,
      });
      // 自动打款与付款账户
      const accountRes = await riskCapital({
        codeType: 'PAY_FEE_LIMIT_SUB_TYPE',
        codeDesc: 4,
        state: 1,
      });
      return {
        order: orderRes.items,
        driver: driverRes.items,
        member: memberRes.items,
        account: accountRes.items,
      };
    },
  },
  async mounted () {
    // await this.$refs.baseForm.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
